module.exports = __webpack_public_path__ + "media/images/landing/bg/screens-company/04-93169e2217fa660931b3981743ccfbf6.png";